<template>
    <v-container colum>
        <h2 class="subtitle">
            Simulators Actions
        </h2>
        <v-row v-if="bays">
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-form ref="optionsForm">
                            <v-row>
                                <v-col cols=3>
                                    Bay
                                </v-col>
                                <v-col cols=9>
                                    <v-select :items="bays" v-model=bay item-text=name item-value=id label="Bay"/>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols=3>
                                    Command
                                </v-col>
                                <v-col cols=9>
                                    <v-select :items="commands" v-model=command label="Command"/>
                                </v-col>
                            </v-row>
                            
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" @click="send">Send command</v-btn>
                        <v-spacer />
                        <v-btn @click="refresh">Refresh Trackman</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-for="bay in bays" :key="'_bay_'+bay.id">
            <v-col>
                <v-card>
                    <v-card-title>
                        {{bay.name}}
                    </v-card-title>
                    <v-card-text>
                        <v-row v-if="bay.desactivate_from && bay.desactivate_to">
                            <v-col cols=9>
                                Desactivated between {{bay.desactivate_from}} to {{bay.desactivate_to}}
                            </v-col>
                            <v-col cols=3>
                                <v-btn @click="cancelDesactivation(bay.id)">Cancel desactivation</v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols=3>
                                Desactivate this bays from
                            </v-col>
                            <v-col cols=2>
                                <v-menu
                                    v-model="fromDatePicker[bay.id]"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="fromDate[bay.id]"
                                        label="From"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="fromDate[bay.id]" @input="fromDatePicker[bay.id] = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols=2>
                                To
                            </v-col>
                            <v-col cols=2>
                                <v-menu
                                    v-model="toDatePicker[bay.id]"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="toDate[bay.id]"
                                        label="To"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="toDate[bay.id]" @input="toDatePicker[bay.id] = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols=3>
                                <v-btn color="primary" @click="desactivate(bay.id)">Desactivate</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    components:{
    },

    data: () => ({
        bay:null,
        command:null,
        commands:[
            {text:"Lock with admin code", value:"lock"},
            {text:"Force UnLock", value:"unlock"}
        ],
        fromDatePicker:{},
        toDatePicker:{},
        toDate:{},
        fromDate:{}
    }),
    computed: {
        ...mapGetters("xperience",["bays"]),
    },
    mounted(){
        this.getBays()
    },
    methods:{
        ...mapActions("xperience",["getBays","sendCommandToBay", "refreshTrackman", "desactivateBay", "cancelDesactivationBay"]),
        send(){
            this.sendCommandToBay({
                bayId:this.bay,
                command:this.command
            })
        },
        refresh(){
            this.refreshTrackman()
            .finally(() => {
                this.getBays()
            })
        },
        desactivate(bayId){
            if(this.fromDate[bayId] && this.toDate[bayId]){
                this.desactivateBay({
                    bayId,
                    from:this.fromDate[bayId],
                    to:this.toDate[bayId]
                })
                .then(() => {
                    this.getBays()
                })
            }
        },
        cancelDesactivation(bayId){
            this.desactivateBay({
                bayId,
                from:null,
                to:null
            })
            .then(() => {
                this.getBays()
            })
        }
    }

}
</script>

<style>

</style>